import { sendGa } from 'reactApp/utils/ga';

export const sendModalGa = (id, action: string): void => {
    sendGa('buy-modal-trial_ga', action, id);
    sendGa('buy-modal-trial_ab', action, 'ab');
};
